import * as yup from 'yup'

export const addContentSchema = yup.object({
	name: yup.string().required(),
	description: yup.string().required(),
	day: yup.string().required(),
	expirationDate: yup.string().required(),
	fileIds: yup.array(yup.object()),
})
